import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './css/Cliente.css';
import axios from 'axios';
import Navbar from './components/Navbar';
import { API_BASE_URL } from '../config/ApiConfig';
import { formatDateView } from './utils/dateUtils';
import Pagination from './components/Pagination';
import ResponsiveShadow from './components/ResponsiveShadow';
import { formatString } from './utils/StringUtils';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import ConfirmModal from './components/modals/ConfirmModal';
import usePagination from './components/hooks/usePagination';
import Footer from './components/Footer';
import TableHeader from './components/TableHeader';

function PcaConsolidacao() {
  const [dfds, setDfds] = useState([]);
  const [selectedDfds, setSelectedDfds] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isExporting, setIsExporting] = useState(false);
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const navigate = useNavigate();
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const totalItems = dfds.length;
  const { setPagination } = usePagination(totalItems);

  const selectedDfdsForPage = dfds.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  const allSelected =
    selectedDfdsForPage.length > 0 &&
    selectedDfdsForPage.every(dfd => selectedDfds.some(d => d.num === dfd.num));

  useEffect(() => {
    axios
      .get(`${API_BASE_URL.DFD}/aprovado`, {
        params: {
          cnpj: cnpj,
          anoBase: localStorage.getItem('anoBase'),
        },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        setDfds(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter listas:', error);
        navigate('/');
      });
  }, []);

  if (!dfds) {
    return <div>Loading...</div>;
  }

  function handleDelete(dfd) {
    showConfirmModal('delete', () => handleDeleteConfirm(dfd));
  }

  async function handleConsolida() {
    if (selectedDfds.length === 0) {
      showDefaultModal('error', 'Selecione pelo menos um DFD para consolidar!');
      return;
    }

    try {
      showDefaultModal(
        'info',
        `Consolidando ${selectedDfds.length} DFDs selecionados...`
      );
      // Envia para a API
      const response = await axios.post(
        `${API_BASE_URL.DFD}/consolidar`,
        selectedDfds,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      // Sucesso: mostrar sucesso
      showDefaultModal('success', response.data);

      // Opcional: atualizar a lista (caso queira buscar de novo)
      // const result = await axios.get(`${API_BASE_URL.DFD}/aprovado`, { params: { cnpj, anoBase: localStorage.getItem('anoBase') }, headers: { Authorization: `Bearer ${token}` } });
      // setDfds(result.data);
      // setSelectedDfds([]);
    } catch (error) {
      console.error('Erro ao consolidar:', error);
      showDefaultModal('error', 'Erro ao consolidar os DFDs.');
    }
  }

  const handleSelectDfd = dfd => {
    setSelectedDfds(prevSelected => {
      const isSelected = prevSelected.some(d => d.num === dfd.num);
      if (isSelected) {
        return prevSelected.filter(d => d.num !== dfd.num);
      } else {
        return [...prevSelected, dfd];
      }
    });
  };

  const handleSelectAll = e => {
    if (e.target.checked) {
      setSelectedDfds(prev => {
        const newSelected = [...prev];
        selectedDfdsForPage.forEach(dfd => {
          if (!newSelected.some(d => d.num === dfd.num)) {
            newSelected.push(dfd);
          }
        });
        return newSelected;
      });
    } else {
      setSelectedDfds(prev =>
        prev.filter(dfd => !selectedDfdsForPage.some(d => d.num === dfd.num))
      );
    }
  };

  function handleDeleteConfirm(itemToDelete) {
    if (itemToDelete) {
      axios
        .get(`${API_BASE_URL.DFD_ITEM}/exists`, {
          params: { cnpj: itemToDelete.cnpj, num: itemToDelete.num },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          if (result.data.exists) {
            showDefaultModal(
              'error',
              'Este possui vínculos e não pode ser excluído. Exclua os vínculos antes de tentar novamente.'
            );
          } else {
            axios
              .delete(`${API_BASE_URL.DFD}/delete`, {
                params: {
                  cnpj: itemToDelete.cnpj,
                  num: itemToDelete.num,
                },
                headers: { Authorization: `Bearer ${token}` },
              })
              .then(result => {
                setDfds(prevState =>
                  prevState.filter(item => item.num !== itemToDelete.num)
                );
                setSelectedDfds(prevState =>
                  prevState.filter(item => item.num !== itemToDelete.num)
                );
                showDefaultModal(
                  'success',
                  'O registro foi excluído com sucesso!'
                );
              })
              .catch(error => {
                console.error('Erro ao excluir o item:', error);
                showDefaultModal('error', 'Erro ao excluir o registro');
              });
          }
        });
    }
  }

  async function handlePrint(dfd) {
    setIsExporting(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL.DFD}/preencherDfd`,
        dfd,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          responseType: 'blob',
        }
      );
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `DFD ${formatString(dfd.num, 4)}.docx`;
      link.click();
    } catch (error) {
      console.error('Erro ao preencher o template:', error);
      showDefaultModal('error', 'Erro ao preencher o template.');
    } finally {
      setIsExporting(false);
    }
  }

  async function handleConsolidaProduto() {
    try {
      showDefaultModal('info', 'Executando consolidação por produto...');
      const url = `${API_BASE_URL.PCA}/consolidar_produto?cnpj=${cnpj}&anoBase=${localStorage.getItem('anoBase')}`;
      const resp = await axios.post(url, null, { headers: { Authorization: `Bearer ${token}` } });
      showDefaultModal('success', resp.data || 'Consolidação por produto finalizada.');
    } catch (err) {
      console.error('Erro consolida por produto', err);
      showDefaultModal('error', 'Erro ao consolidar por produto.');
    }
  }

  const [consolidados, setConsolidados] = useState([]);
  const [showConsolidadosModal, setShowConsolidadosModal] = useState(false);

  async function handleVerConsolidados() {
    try {
      const url = `${API_BASE_URL.PCA}/consolidada/all?cnpj=${cnpj}&anoBase=${localStorage.getItem('anoBase')}`;
      const resp = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      setConsolidados(resp.data || []);
      setShowConsolidadosModal(true);
    } catch (err) {
      console.error('Erro ao obter consolidados', err);
      showDefaultModal('error', 'Erro ao obter consolidados.');
    }
  }

  return (
    <div className="full-screen-div">
      <Navbar />
      <div className="container mt-4 pt-5">
        <ResponsiveShadow className="container mt-4 mb-4">
          <div className="d-flex justify-content-between align-items-center pt-3 pb-2">
            <h6 className="text-secondary">
              DFD PARA A ELABORAÇÃO DO PCA
            </h6>
            <div className="d-flex align-items-center">
              <Link
                className="btn btn-secondary btn-sm d-inline-flex align-items-center me-2"
                to="/home"
              >
                <i className="bi bi-house" />
              </Link>
                <button
                  onClick={() => handleConsolida()}
                  className="btn btn-success btn-sm d-inline-flex align-items-center me-2"
                >
                  <i className="bi bi-stack me-1" /> Consolidar DFDs
                </button>
                <button
                  onClick={() => handleConsolidaProduto()}
                  className="btn btn-primary btn-sm d-inline-flex align-items-center me-2"
                >
                  <i className="bi bi-box-seam me-1" /> Consolidar por Produto
                </button>
                <button
                  onClick={() => handleVerConsolidados()}
                  className="btn btn-info btn-sm d-inline-flex align-items-center"
                >
                  <i className="bi bi-table me-1" /> Ver Consolidados
                </button>
            </div>
          </div>

          <div className="table-responsive-sm">
            <table className="table table-hover table-striped table-sm small table-custom-radius">
              <TableHeader columns={[
                { label: <input type="checkbox" checked={allSelected} onChange={handleSelectAll} />, width: '3%' },
                { label: 'DFD', width: '5%' },
                { label: 'Data da Contratação', width: '7%' },
                { label: 'Área Requisitante', width: '20%' },
                { label: 'Objeto' },
                { label: 'Tramitação', width: '15%' },
                { label: 'Ações', width: '5%', align: 'center' },
              ]} />
              <tbody>
                {selectedDfdsForPage.length > 0 ? (
                  selectedDfdsForPage.map(c => (
                    <tr key={`${c.cnpj}-${c.num}`}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedDfds.some(d => d.num === c.num)}
                          onChange={() => handleSelectDfd(c)}
                        />
                      </td>
                      <td style={{ width: '5%' }}>{formatString(c.num, 4)}</td>
                      <td style={{ width: '7%' }}>
                        {formatDateView(c.dataContratacao)}
                      </td>
                      <td style={{ width: '20%' }}>{c.requisitante}</td>
                      <td>{c.objeto}</td>
                      <td style={{ width: '15%' }}>{c.tramitacao}</td>
                      <td className="text-center" style={{ width: '5%' }}>
                        <div className="dropdown">
                          <button
                            className="btn btn-sm p-1"
                            type="button"
                            id={`dropdownMenuButton-${c.num}`}
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i className="bi bi-three-dots-vertical" />
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby={`dropdownMenuButton-${c.num}`}
                          >
                            <li>
                              <Link
                                to="/pca_itens_consolidados"
                                state={{ dfd: c }}
                                className="dropdown-item text-success"
                              >
                                <i className="bi bi-boxes me-1" /> Itens
                              </Link>
                            </li>
                            <li>
                              <button
                                onClick={() => handlePrint(c)}
                                className="dropdown-item"
                              >
                                <i className="bi bi-printer me-1" /> Imprimir
                              </button>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      Nenhum registro encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination {...setPagination} />
          </div>
        </ResponsiveShadow>
      </div>
      <DefaultModal {...setDefaultModal} />
      <ConfirmModal {...setConfirmModal} />
      <Footer />
      {/* Modal simples para exibir consolidados */}
      {showConsolidadosModal && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Consolidados</h5>
                <button type="button" className="btn-close" onClick={() => setShowConsolidadosModal(false)} />
              </div>
              <div className="modal-body">
                {consolidados.length === 0 ? (
                  <div>Nenhum consolidado encontrado.</div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm table-striped table-custom-radius">
                      <TableHeader columns={[
                        { label: 'Descrição' },
                        { label: 'Qtde Total' },
                        { label: 'VLr Unit' },
                        { label: 'DFDs' },
                        { label: 'Itens' },
                      ]} />
                      <tbody>
                        {consolidados.map((c, idx) => (
                          <tr key={idx}>
                            <td>{c.descricaoItem}</td>
                            <td>{c.qtdeTotal}</td>
                            <td>{c.vlrUnitario}</td>
                            <td>{c.listaDfds}</td>
                            <td>{c.listaItens}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowConsolidadosModal(false)}>Fechar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default PcaConsolidacao;
